<route-container
  [uid]="chatbotUuid"
>
  <loader-container
    [loader]="loader"
    [options]="{
      contentTemplate: preview
    }"
    (loaded)="chatbot = $event"
  ></loader-container>
</route-container>

<ng-template #preview>
  <div *ngIf="chatbot">
      <data-preview
        [item]="chatbot"
        [options]="{
          properties: {
            'id': { heading: 'UID', order: 1 },
            'name': { heading: 'Name', order: 2 },
            'description': { heading: 'Description', order: 4 },
            'tenant': { heading: 'Tenant', order: 3, valueRenderTemplate: tenantId },
            'contextVars': {
              heading: 'Context Vars',
              order: 5,
              valueRenderTemplate: contextVars
            },
            'settings': {
              heading: 'Settings',
              order: 6,
              valueRenderTemplate: settings
            },
          }
        }"
      ></data-preview>
      <actions-container *ngIf="!hideActions" [ngClass]="'pb-4'">
        <back-button></back-button>
        <button mat-raised-button color="primary"
                [routerLink]="['./rag-context']">
          <mat-icon class="valign-middle">account_tree</mat-icon> Context
        </button>
        <button mat-raised-button color="primary"
          [routerLink]="['./config']">
          <mat-icon class="valign-middle">tune</mat-icon> Change Settings
        </button>
      </actions-container>
  </div>
</ng-template>

<ng-template #tenantId let-propertyValue=propertyValue>
  <tenant-id-tag
    [tenantId]="propertyValue"
  ></tenant-id-tag>
</ng-template>

<ng-template #settings let-propertyValue=propertyValue>
  <ul *ngIf="propertyValue" class="text-secondary">
    <li>
      Session History:
      <span class="text-primary"
        [ngClass]="{ 'text-danger': !propertyValue['useSessionHistory']}"
      >{{propertyValue["useSessionHistory"]}}</span>
    </li>
    <li>
      History Cap:
      <span class="text-primary"
            [ngClass]="{ 'text-danger': !propertyValue['maxSessionHistorySize']}"
      >{{propertyValue["maxSessionHistorySize"]}}</span>
    </li>
    <li *ngIf="propertyValue['ragSearch']">
      RAG Search Configs
      (<span
        class="click-able text-primary" (click)="settingDetails = !settingDetails"
      >{{settingDetails ? 'Hide' : 'Show' }}</span>)
      <div *ngIf="settingDetails">
        <ul class="fw-light">
          <li *ngFor="let c of Object.getOwnPropertyNames(propertyValue['ragSearch'])">
            {{c}} (<span
              [ngClass]="{ 'text-danger': propertyValue['ragSearch'][c]['disabled'] }"
            >{{propertyValue['ragSearch'][c]['disabled'] ? 'DISABLED' : 'Enabled'}}</span>)
            <span><br />RAG Min Score:
              <span class="d-inline text-primary">{{propertyValue['ragSearch'][c]["ragMinSearchScore"]}}</span>
            </span>
            <ul *ngFor="let v of Object.getOwnPropertyNames(propertyValue['ragSearch'][c]['searchConfig'])">
              {{v}} = {{propertyValue['ragSearch'][c]['searchConfig'][v]}}
            </ul>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</ng-template>

<ng-template #contextVars let-propertyValue=propertyValue>
  <ul *ngIf="propertyValue" class="text-secondary">
    <li *ngFor="let v of propertyValue">
      <a class="link-underline-light" [routerLink]="['./rag-context', v]">{{v}}</a>
    </li>
  </ul>
</ng-template>
